import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Steps, { Step } from 'rc-steps';
import { getRequest } from '../../../requestUtils';
import './SideNavStepProgressBar.scss';
import chatLogo from '../../../../assets/images/clora-chat-logo.svg';
import { analyticsTrack } from '../../../analyticsUtils';

const setStepStatus = (currentStep, step, completed) => {
  if (currentStep === step) {
    return 'process';
  }

  return completed ? 'finish' : 'wait';
};

class SideNavStepProgressBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onboardingMenu: [],
      currentStep: null,
    };

    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.getOnboardingMenu = this.getOnboardingMenu.bind(this);
  }

  componentDidMount() {
    this.getOnboardingMenu();
  }

  componentDidUpdate() {
    const { updateMenu, handleMenuUpdate } = this.props;
    if (updateMenu) {
      this.getOnboardingMenu();
      handleMenuUpdate(false);
    }
  }

  getOnboardingMenu() {
    const { userId } = this.props;
    getRequest(`/users/${userId}/onboarding_menu`)
      .then(({ data }) => {
        this.setState({
          onboardingMenu: data,
          currentStep: data.find((item) => item.status === 'process'),
        });
      });
  }

  handleMenuClick(currentStep) {
    const state = currentStep === 0 ? 0 : 1;
    const { onboardingMenu } = this.state;
    const { title } = onboardingMenu[currentStep];

    analyticsTrack(
      'Using Progress bar to advance',
      { location: 'Onboarding Flow', step: title },
    );
    this.props.handleMenuClick(state, currentStep);
  }

  renderStep(stepIndex, title, status, description, disabled, step) {
    return (
      <Step
        stepIndex={stepIndex}
        title={title}
        description={description}
        status={setStepStatus(step, stepIndex, status)}
        onStepClick={this.handleMenuClick}
      />
    );
  }

  renderOnboardingMenu() {
    const { step, uploadingResume } = this.props;
    const { onboardingMenu } = this.state;

    return (
      <Steps
        direction="vertical"
        current={step || 0}
      >
        {onboardingMenu.map((menu) => (
          this.renderStep(
            menu.stepIndex,
            menu.title,
            menu.completed,
            menu.description,
            uploadingResume,
            step,
          )
        ))}
      </Steps>
    );
  }

  render() {
    return (
      <div className="side-nav-container">
        {this.renderOnboardingMenu()}
        <div className="message-cta">
          <img src={chatLogo} alt="ligh bulb" />
          <div className="message-text">
            <div className="small-text">Need help?</div>
            <div className="large-text">Chat with us!</div>
          </div>
        </div>
      </div>
    );
  }
}

SideNavStepProgressBar.propTypes = {
  step: PropTypes.number.isRequired,
  userId: PropTypes.string.isRequired,
  updateMenu: PropTypes.bool.isRequired,
  handleMenuUpdate: PropTypes.func.isRequired,
  handleMenuClick: PropTypes.func.isRequired,
  uploadingResume: PropTypes.bool,
};

SideNavStepProgressBar.defaultProps = {
  uploadingResume: false,
};

export default SideNavStepProgressBar;
